module.exports = __webpack_public_path__ + "img/FR30568.8eeb91fd.png";